import React, { useEffect, useState } from 'react';
import { Mail, Briefcase, Handshake, UsersRound } from 'lucide-react';
import { useSupabase } from '../hooks/useSupabase';
import { abvigAPI } from '../services/api';
import StatsCard from '../components/Dashboard/StatsCard';
import RecentActivity from '../components/Dashboard/RecentActivity';
import { BarChartWidget, PieChartWidget } from '../components/Dashboard/ChartWidget';

export default function AbvigDashboard() {
  const [stats, setStats] = useState(null);
  const { data: messages } = useSupabase(abvigAPI.getContactMessages);
  const { data: applications } = useSupabase(abvigAPI.getInternApplications);
  // eslint-disable-next-line no-unused-vars
  const { data: partnerships } = useSupabase(abvigAPI.getPartnershipInquiries);

  useEffect(() => {
    const loadStats = async () => {
      const statsData = await abvigAPI.getDashboardStats();
      setStats(statsData);
    };
    loadStats();
  }, []);

  // Prepare chart data
  const statusData = [
    { name: 'Pending', value: stats?.pendingMessages || 0 },
    { name: 'Resolved', value: (stats?.totalMessages || 0) - (stats?.pendingMessages || 0) },
  ];

  // eslint-disable-next-line no-unused-vars
  const applicationData = [
    { name: 'Pending', value: stats?.pendingApplications || 0 },
    { name: 'Reviewed', value: (stats?.totalApplications || 0) - (stats?.pendingApplications || 0) },
  ];

  const monthlyData = [
    { month: 'Jan', messages: 45 },
    { month: 'Feb', messages: 52 },
    { month: 'Mar', messages: 38 },
    { month: 'Apr', messages: 61 },
    { month: 'May', messages: 48 },
    { month: 'Jun', messages: 55 },
  ];

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">ABVIG Dashboard</h1>
        <p className="text-gray-600">Overview of all ABVIG activities</p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        <StatsCard
          title="Contact Messages"
          value={stats?.totalMessages || 0}
          icon={Mail}
          color="primary"
          subtitle={`${stats?.pendingMessages || 0} pending`}
        />
        <StatsCard
          title="Intern Applications"
          value={stats?.totalApplications || 0}
          icon={Briefcase}
          color="secondary"
          subtitle={`${stats?.pendingApplications || 0} pending`}
        />
        <StatsCard
          title="Partnerships"
          value={stats?.totalPartnerships || 0}
          icon={Handshake}
          color="green"
          subtitle={`${stats?.pendingPartnerships || 0} pending`}
        />
        <StatsCard
          title="Subscribers"
          value={stats?.totalSubscribers || 0}
          icon={UsersRound}
          color="blue"
        />
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
        <div className="lg:col-span-2">
          <BarChartWidget
            data={monthlyData}
            dataKey="messages"
            xAxisKey="month"
            title="Monthly Contact Messages"
            color="#c53030"
          />
        </div>
        <div>
          <PieChartWidget
            data={statusData}
            title="Message Status"
          />
        </div>
      </div>

      {/* Recent Activity */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <RecentActivity 
          data={messages?.slice(0, 5) || []} 
          title="Recent Contact Messages"
        />
        <RecentActivity 
          data={applications?.slice(0, 5) || []} 
          title="Recent Applications"
        />
      </div>
    </div>
  );
}